import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const enginesPlugin = createPlugin({
  id: 'engines-next',
  routes: {
    root: rootRouteRef,
  },
  featureFlags: [
    {
      name: 'engines-next',
    },
  ],
});

export const EnginesPage = enginesPlugin.provide(
  createRoutableExtension({
    name: 'EnginesPage',
    component: () => import('./components/index').then(m => m.IndexPage),
    mountPoint: rootRouteRef,
  }),
);
